import React, { useState } from 'react';
import Card from 'react-bootstrap/Card';
import { Button } from 'react-bootstrap';
import { Badge } from 'react-bootstrap';
import Viewer from 'react-viewer';
import Table from 'react-bootstrap/Table';
import Switch from 'react-bootstrap-switch';
import ModalAddCar from '../modal/ModalAddCar';
import Modal from 'react-bootstrap/Modal';

export default function TableCar(props) {
  const [image, setImage] = useState([{ src: '', alt: '' }]);
  const [visible, setVisible] = React.useState(false);
  const [showMd, setShowMd] = useState(false);

  const [editItem, setEditItem] = useState(null);

  const handleMdNew = () => {
    setEditItem(null);
    setShowMd(true);
  };

  // 💡 เพิ่มฟังก์ชันเมื่อคลิกปุ่มแก้ไขที่ท้ายแถวรถ
  const handleMdEdit = (carItem) => {
    setEditItem(carItem); // บันทึกข้อมูลรถคันที่จะแก้ลง State
    setShowMd(true);      // เปิด Modal ตัวเดียวกัน (หรือจะส่งไปกระจายค่าใน ModalAddCar ต่อ)
  };

  const addCarWs = (input, file) => {
    console.log('1. ข้อมูลตัวหนังสือ:', input);
    console.log('2. ข้อมูลไฟล์ภาพที่ตามมาด้วย:', file);
    if (editItem) {
      // 💡 ถ้ามีข้อมูลรถเก่าค้างอยู่ใน State แปลว่าเขากดส่งจากโหมดแก้ไข
      if (props.onEdit) {
        props.onEdit(input, file);
      }
    } else {
      props.onCreate(input, file);
    }
  };

  return (
    <div>
      <Modal show={showMd} size={'lg'} onHide={() => setShowMd(false)}>
        <Modal.Header closeButton>
          {/* 💡 ปรับ Title ของ Modal ให้สลับตามโหมดการใช้งาน */}
          <Modal.Title>{editItem ? 'แก้ไขข้อมูลรถส่วนตัว' : 'เพิ่มรถ'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalAddCar
            dropdownsMaster={props.dropdownsMaster}
            editItem={editItem} // 💡 ส่งข้อมูลรถที่ต้องการแก้ไขเข้าไปใน Component ลูกด้วย
            onAdd={(input, file) => {
              addCarWs(input, file);
              setShowMd(false);
            }}
          ></ModalAddCar>
        </Modal.Body>
      </Modal>

      <Viewer
        zoomSpeed={0.2}
        zIndex={9999}
        visible={visible}
        onClose={() => {
          setVisible(false);
        }}
        images={image}
      />

      <Card className="card">
        <Card.Header className="d-flex">
          <div className="p-10 col-8 col-md-10">
            รายการรถของคุณทั้งหมด, เพิ่มหรือปิด-เปิดตัวเลือกในตอนวางแผนได้
          </div>
          <div className="ml-auto">
            <Button
              className="btn-xs"
              variant="outline-primary"
              onClick={handleMdNew}
            >
              + เพิ่มรถ
            </Button>
          </div>
        </Card.Header>
        <Table striped style={{ verticalAlign: 'middle' }}>
          <thead>
            <tr>
              <th>แสดงตอนสร้างแผน</th>
              <th className="d-none d-sm-table-cell">#</th>
              <th className="d-none d-sm-table-cell">สถานะ</th>
              <th className="d-none d-sm-table-cell">ยี่ห้อ / รุ่น</th>
              <th className="d-none d-sm-table-cell">ทะเบียน</th>
              <th className="d-none d-lg-table-cell">ประเภท</th>
              <th className="d-none d-lg-table-cell">ขนาดเครื่องยนต์ (cc)</th>
              <th className="d-none d-lg-table-cell">เชื้อเพลิง</th>
              <th>จัดการ / รูปถ่าย</th> {/* 💡 ปรับหัวตารางให้ครอบคลุมการจัดการ */}
            </tr>
          </thead>
          <tbody>
            {props.cars ? (
              Array.isArray(props.cars) && props.cars.map((e) => {
                return (
                  <tr key={`car-${e.VehicleId}`}>
                    <td style={{ verticalAlign: 'middle' }}>
                      <div className="d-flex flex-column align-items-start">
                        <Switch
                          bsSize={'mini'}
                          disabled={e.VehicleStatus !== 'A'} // ล็อกการกด
                          onChange={async (el, state) => {
                            const result = await props.updateCarWs({
                              VehicleId: e.VehicleId,
                              IsActive: state ? 'Y' : 'N'
                            });
                          }}
                          value={e.IsActive === 'Y'}
                        />

                        {/* 💡 ถ้าสถานะไม่ใช่ A ให้โชว์ตัวหนังสือเตือนตัวเล็กๆ ใต้สวิตช์ */}
                        {e.VehicleStatus !== 'A' && (
                          <span className="text-muted mt-1" style={{ fontSize: '10px', whiteSpace: 'nowrap' }}>
                            *เปิดใช้ได้เมื่ออนุมัติแล้ว
                          </span>
                        )}
                      </div>
                    </td>
                    <td className="d-none d-sm-table-cell">{e.VehicleId}</td>

                    {/* 🟢 ส่วนพื้นที่แสดงสถานะและคำคอมเมนต์ (RejectReason) */}
                    <td className="d-none d-sm-table-cell" style={{ verticalAlign: 'middle' }}>
                      {e.VehicleStatus === 'P' && (
                        <span
                          className="badge badge-warning text-dark"
                          style={{ padding: '6px 12px', borderRadius: '20px', fontWeight: '500', fontSize: '13px' }}
                        >
                          กำลังตรวจสอบ
                        </span>
                      )}
                      {e.VehicleStatus === 'A' && (
                        <span
                          className="badge badge-success text-white"
                          style={{ padding: '6px 12px', borderRadius: '20px', fontWeight: '500', fontSize: '13px', backgroundColor: '#28a745' }}
                        >
                          CR อนุมัติ
                        </span>
                      )}
                      {e.VehicleStatus === 'F' && (
                        <div className="d-flex flex-column align-items-start">
                          <span
                            className="badge badge-danger text-white"
                            style={{ padding: '6px 12px', borderRadius: '20px', fontWeight: '500', fontSize: '13px', backgroundColor: '#dc3545' }}
                          >
                            Rejected
                          </span>
                          {/* 💡 ดึงค่า RejectReason ที่ได้จากหลังบ้านมาโชว์ที่นี่เป็นกล่องคำเตือน */}
                          {e.RejectReason && (
                            <div
                              className="text-danger mt-1"
                              style={{ fontSize: '11px', fontWeight: '600', maxWidth: '180px', wordBreak: 'break-word', lineHeight: '1.3' }}
                            >
                              ⚠️ เหตุผล: <span className="text-muted">{e.RejectReason}</span>
                            </div>
                          )}
                        </div>
                      )}
                      {!['P', 'A', 'F'].includes(e.VehicleStatus) && (
                        <span
                          className="badge badge-secondary text-white"
                          style={{ padding: '6px 12px', borderRadius: '20px', fontWeight: '500', fontSize: '13px' }}
                        >
                          ไม่ระบุสถานะ
                        </span>
                      )}
                    </td>

                    <td className="d-none d-sm-table-cell">{e.BrandModel}</td>
                    <td className="d-none d-sm-table-cell">
                      {e.RegisNumber} {e.ProvinceNameTH}
                    </td>
                    <td>{e.VehicleTypeName}</td>
                    <td className="d-none d-sm-table-cell">{e.EngineCC}</td>
                    <td className="d-none d-lg-table-cell">{e.FuelTypeName}</td>

                    {/* 🟢 ส่วนแสดงรูปถ่ายและเพิ่มปุ่มแก้ไขข้อมูล */}
                    <td style={{ verticalAlign: 'middle' }}>
                      <div className="d-flex align-items-center">
                        <img
                          onClick={() => {
                            setVisible(true);
                            setImage([{ src: e.Url.replace('?size=300', ''), alt: '' }]);
                          }}
                          src={e.Url}
                          style={{ cursor: 'pointer' }}
                          className="img-rounded img-size-32 mr-2"
                        />

                        <img
                          onClick={() => {
                            setVisible(true);
                            setImage([{ src: e.Url2.replace('?size=300', ''), alt: '' }]);
                          }}
                          src={e.Url2}
                          style={{ cursor: 'pointer' }}
                          className="img-rounded img-size-32 mr-2"
                        />

                        {/* 💡 เพิ่มปุ่ม "แก้ไขข้อมูล" ขึ้นมาเฉพาะแถวรถที่มีสถานะถูกปฏิเสธ ('F') เท่านั้น */}
                        {e.VehicleStatus === 'F' && (
                          <Button
                            variant="primary"
                            className="btn-xs p-1 px-2 shadow-sm ml-2"
                            style={{ fontSize: '11px', fontWeight: 600, borderRadius: '4px' }}
                            onClick={() => handleMdEdit(e)}
                          >
                            <i className="fas fa-edit mr-1"></i> แก้ไข
                          </Button>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <></>
            )}
          </tbody>
        </Table>
      </Card>
    </div>
  );
}
